import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { ChevronRight, LucideIcon } from 'lucide-react';

interface ProfileListSectionProps {
  title: string;
  icon: LucideIcon;
  iconColor: string;
  badgeColor: string;
  buttonColor: string;
  profiles: any[];
  viewMode: 'grid' | 'list';
  renderProfileCard: (profile: any, isPremium?: boolean) => React.ReactNode;
  onViewAll?: () => void;
  viewAllText?: string;
  maxPreview?: number;
  showPremiumBadge?: boolean;
  showCount?: boolean;
}

export default function ProfileListSection({
  title,
  icon: Icon,
  iconColor,
  badgeColor,
  buttonColor,
  profiles,
  viewMode,
  renderProfileCard,
  onViewAll,
  viewAllText = 'View All',
  maxPreview = 8,
  showPremiumBadge = false,
  showCount = true
}: ProfileListSectionProps) {
  // Don't render the section if there are no profiles
  if (!profiles || profiles.length === 0) {
    return null;
  }

  const displayProfiles = maxPreview > 0 ? profiles.slice(0, maxPreview) : profiles;

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon className={`size-6 ${iconColor}`} />
          <h2 className="text-2xl font-semibold">{title}</h2>
          {showCount && (
            <Badge className={badgeColor}>
              {profiles.length}
            </Badge>
          )}
        </div>
        {onViewAll && profiles.length > 0 && (
          <Button
            size="sm"
            variant="default"
            className={buttonColor}
            onClick={onViewAll}
          >
            {viewAllText}
            <ChevronRight className="size-4 ml-1" />
          </Button>
        )}
      </div>
      <div className={viewMode === 'grid' ? 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 auto-rows-max' : 'space-y-4'}>
        {displayProfiles.map((profile) => renderProfileCard(profile, showPremiumBadge))}
      </div>
    </div>
  );
}